var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_vm._l((_vm.booking),function(booking,i){return _c('div',{key:i,staticStyle:{"padding-bottom":"25px"}},[_c('BookingCard',{attrs:{"booking":booking}})],1)})],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","align-items":"left","justify-content":"left","padding-bottom":"25px"}},[_c('span',{staticClass:"title-user-scr-b"},[_vm._v("Elige un salón")])])
}]

export { render, staticRenderFns }